const HTTP_URL = process.env.REACT_APP_HTTP_URL ?? '';
export const serverOrigin = HTTP_URL.replace(/\/graphql\/?$/, '');
// Session-scoped proxy: the back-end resolves the FiscalPOP authToken from the session cookie
export const API_BASE = `${serverOrigin}/proxy/fiscal`;

const enc = encodeURIComponent;

export const endpoints = {
    cfdi: {
        findBy: (startMs: number, endMs: number, flags?: Record<string, boolean>) => {
            const qs = new URLSearchParams({ from: String(startMs), to: String(endMs) });
            Object.entries(flags ?? {}).forEach(([k, v]) => qs.set(k, String(v)));
            return `${API_BASE}/cfdis?${qs.toString()}`;
        },
        find: (uuid: string) => `${API_BASE}/cfdis/${enc(uuid)}`,
        status: (uuid: string) => `${API_BASE}/cfdis/${enc(uuid)}/status`,
        downloadXml: (uuid: string) => `${API_BASE}/cfdis/${enc(uuid)}/xml`,
        downloadPdf: (uuid: string) => `${API_BASE}/cfdis/${enc(uuid)}/pdf`,
        downloadPaymentXml: (uuid: string) => `${API_BASE}/billing/cfdis/${enc(uuid)}/xml`,
        downloadPaymentPdf: (uuid: string) => `${API_BASE}/billing/cfdis/${enc(uuid)}/pdf`,
    },
    sat: {
        productosServicios: () => `${API_BASE}/catalogs/products/search`,
        claveUnidades: () => `${API_BASE}/catalogs/units/search`,
        usoCfdi: () => `${API_BASE}/catalogs/cfdi-uses`,
        payTypes: () => `${API_BASE}/catalogs/payment-types`,
    },
    uploads: {
        cer: () => `${API_BASE}/certificates/cer`,
        key: () => `${API_BASE}/certificates/key`,
        logo: (extension: string) => `${API_BASE}/logo?extension=${enc(extension)}`,
    },
};
